/* eslint-disable @typescript-eslint/naming-convention */
export interface ErrorMessageData {
   details: string | null;
   userMessages: string[];
}

export type ErrorUnion = ErrorMessage | RestApiError | BatchGraphErrors | SingleGraphError;

export enum ExceptionType {
   ErrorMessage,
   RestApi,
   BatchGraph,
   Graph,
   RawHttpError,
}

export interface RawApiError {
   ExceptionMessage: string;
   ExceptionType: string;
   InnerException?: RawApiError;
   Message: string;
   StackTrace?: string;
   status?: number;
}

export interface ErrorMessage {
   exceptionType: ExceptionType;
   status?: number;
   UserMessage: string;
   userMessage: string;
}

interface AdditionalData {
   Details: string;
   Exception: string;
}

interface Exception extends ErrorMessage {
   AdditionalData?: AdditionalData;
   Details?: string;
   DeveloperMessage?: string;
   Exception?: string;
}

export interface RestApiError extends Exception {
   InnerException?: string;
   MoreInfoUri?: string;
}

export interface BatchGraphErrors {
   error: GraphError[];
   exceptionType: ExceptionType;
   status?: number;
}

export interface SingleGraphError {
   exceptionType: ExceptionType;
   error: GraphError;
   status?: number;
}

export interface GraphError {
   data: any;
   errors: {
      locations: { line: number; column: number }[];
      path: string[];
      message: string;
      extensions: {
         data: Exception;
         code: string;
      };
   }[];
}

export type ErrorResponse = {
   error: ErrorObj;
   ExceptionType: ExceptionType.Graph;
};

interface ErrorObj {
   errors: ErrorDetail[];
}
interface ErrorDetail {
   message: string;
   locations: Location[];
   path: string[];
   extensions: Extensions;
}

interface Location {
   line: number;
   column: number;
}

interface Extensions {
   code: string;
   codes: string[];
   data: SqlErrorData;
}

interface SqlErrorData {
   'Server Error Code': number;
   'SqlState': string;
   'UserMessage': string;
}

export function isErrorMessage(errorMessage: ErrorUnion): errorMessage is ErrorMessage {
   return !!errorMessage && errorMessage.exceptionType === ExceptionType.ErrorMessage;
}

export function isRestApiError(errorMessage: ErrorUnion): errorMessage is RestApiError {
   return !!errorMessage && errorMessage.exceptionType === ExceptionType.RestApi;
}

export function isBatchGraphError(errorMessage: ErrorUnion): errorMessage is BatchGraphErrors {
   return !!errorMessage && errorMessage.exceptionType === ExceptionType.BatchGraph;
}

export function isGraphError(errorMessage: ErrorUnion): errorMessage is SingleGraphError {
   return !!errorMessage && errorMessage.exceptionType === ExceptionType.Graph;
}

export function isErrorResponse(errorMessage): errorMessage is ErrorResponse {
   return (errorMessage as ErrorResponse)?.error?.errors?.[0]?.message !== undefined;
}
